import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import PropTypes from "prop-types";

const EmptyState = ({ onAddNew, message = "No Roles Found" }) => {
  const handleSetupClick = () => {
    if (onAddNew) {
      onAddNew();
    }
  };

  return (
    <div className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto">
      <WebIcon
        icon="RoleHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="mb-4 heading-large whitespace-nowrap font-bold text-lighterGrey">
        {message}
      </h2>
      <p className="mb-8 font-normal text-bold-x text-lighterGrey">
        {message.includes("search")
          ? "Try adjusting your search or filter criteria"
          : "Start by adding new roles to manage user permissions."}
      </p>
      {!message.includes("search") && (
        <Button
          text="ADD NEW ROLE"
          color="primary"
          className="w-full px-6 py-3 font-medium text-white"
          customBgColor="primary"
          customTextColor="white"
          onClick={handleSetupClick}
        />
      )}
    </div>
  );
};

EmptyState.propTypes = {
  onAddNew: PropTypes.func,
  message: PropTypes.string,
};

export default EmptyState;
